import { ArrowDown } from 'lucide-react'
import { FunnelBadge } from '../shared/FunnelBadge'
import type { FunnelStep } from '../../types'

interface StepsFlowProps {
  steps: FunnelStep[]
}

export function StepsFlow({ steps }: StepsFlowProps) {
  return (
    <div
      className="rounded-lg border p-4"
      style={{
        borderColor: 'var(--fn-border)',
        backgroundColor: 'var(--fn-bg-card)',
      }}
    >
      <h3 className="text-sm font-semibold mb-3 text-fn-text">
        Steps Flow
      </h3>

      {steps.length === 0 ? (
        <p className="text-xs text-center py-6 text-fn-text-muted">
          No steps configured
        </p>
      ) : (
        <div className="space-y-2">
          {steps.map((step, index) => (
            <div key={step.id}>
              <div
                className="p-2 rounded border"
                style={{
                  borderColor: 'var(--fn-border)',
                  backgroundColor: 'var(--fn-bg-hover)',
                }}
              >
                <div className="flex items-center gap-2">
                  <div
                    className="flex items-center justify-center w-5 h-5 rounded-full text-xs font-medium flex-shrink-0 text-fn-primary"
                    style={{
                      backgroundColor: 'var(--fn-primary-light)',
                    }}
                  >
                    {index + 1}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium truncate text-fn-text">
                      {step.name || `Step ${index + 1}`}
                    </p>
                  </div>
                  <FunnelBadge type="step" value={step.stepType} />
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="flex justify-center py-1">
                  <ArrowDown className="w-4 h-4 text-fn-text-muted" />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
